function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "1.-Rollover-Call-Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.2.-Rollover-Call-Dashboard",
  transform: "translate(-64.000000, -343.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon---Male",
  transform: "translate(64.000000, 343.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.33333333,7.33333333 C7.62,7.33333333 8.66666667,8.38 8.66666667,9.66666667 C8.66666667,10.9533333 7.62,12 6.33333333,12 C5.04666667,12 4,10.9533333 4,9.66666667 C4,8.38 5.04666667,7.33333333 6.33333333,7.33333333 Z M6.33333333,6 C4.30666667,6 2.66666667,7.64 2.66666667,9.66666667 C2.66666667,11.6933333 4.30666667,13.3333333 6.33333333,13.3333333 C8.36,13.3333333 10,11.6933333 10,9.66666667 C10,8.89333333 9.76,8.18 9.35333333,7.58666667 L12,4.94666667 L12,6.66666667 L13.3333333,6.66666667 L13.3333333,2.66666667 L9.33333333,2.66666667 L9.33333333,4 L11.0533333,4 L8.40666667,6.64666667 C7.82,6.24 7.10666667,6 6.33333333,6 Z",
  id: "Shape",
  fill: "#0AA6A8"
}))));

function SvgGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EA75C721-67B2-47E7-A355-8F3D6EE69652@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.516e948e.svg";
export { ForwardRef as ReactComponent };